import { PropsWithChildren } from "react"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"

import { REACT_QUERY_DEV_TOOLS_ENABLED } from "utils/env-management"
import { queryClient } from "utils/infrastructure/query-client"

export function AppQueryClientProvider({ children }: PropsWithChildren<unknown>) {
    return (
        <QueryClientProvider client={queryClient}>
            {children} {REACT_QUERY_DEV_TOOLS_ENABLED && <ReactQueryDevtools />}
        </QueryClientProvider>
    )
}
